import clsx from "clsx";

const SkeletonBlock = ({ className = "" }) => (
    <div
        className={clsx(
            "relative overflow-hidden rounded-md bg-gray-100",
            className,
        )}
    >
        <div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/80 to-transparent"
            style={{
                transform: "translateX(-100%)",
                animation: "shimmer 1.8s linear infinite",
            }}
        />
        <style>{`
        @keyframes shimmer {
          to { transform: translateX(100%); }
        }
      `}</style>
    </div>
);

export default SkeletonBlock;